// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mrSU","question":"styles_question__3fRds","inputVisibleButton":"styles_inputVisibleButton__2h7_U","note":"styles_note__1kDxH"};